/**
 * The angular tabs module
 * @author: nerv
 * @version: 0.2.5, 2012-08-25
 */
'use strict';
export default angular.module('theme', ['ngMaterial'])
    .config(function ($mdThemingProvider) {
    $mdThemingProvider.disableTheming();
})
    .name;
//# sourceMappingURL=theme.js.map